import(/* webpackMode: "eager", webpackExports: ["FAQPageContent"] */ "/home/vesper/code/resume-plus/apps/next/app/(main)/faq/faq-content.tsx");
